import { useMatches } from 'react-router'
import { Button, Stack } from '~/components-v2'
import { trialText } from '~/config'

export const FooterCta = () => {
  const matches = useMatches()
  const isCareers = matches.some(
    (match) =>
      (match.handle as { careersFooter?: boolean } | undefined)?.careersFooter,
  )

  if (isCareers) {
    return (
      <section className="footer-cta careers">
        <div className="footer-cta-inner">
          <Stack className="footer-cta-content" gap={13}>
            <Stack align="center" gap={5}>
              <h2>Join us</h2>
            </Stack>

            <div className="footer-cta-actions">
              <Button
                href="https://jobs.ashbyhq.com/omni"
                external
                variant="primary"
              >
                See open roles
              </Button>
            </div>
          </Stack>
        </div>
      </section>
    )
  }

  return (
    <section className="footer-cta">
      <div className="footer-cta-inner">
        <Stack className="footer-cta-content" gap={8}>
          <Stack align="center" gap={5}>
            <h2>Try Omni today</h2>
            <p>
              Schedule a 1:1 meeting with our team to try Omni with your data.
            </p>
          </Stack>

          <div className="footer-cta-actions">
            <Button to={trialText.to} variant="inverse">
              Try for Free
            </Button>
            <Button to="/request-demo" variant="primary">
              Get a Demo
            </Button>
          </div>
        </Stack>
      </div>
    </section>
  )
}
